import { Component, OnInit } from '@angular/core';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-more-details',
  templateUrl: './more-details.component.html',
  styleUrls: ['./more-details.component.css']
})
export class MoreDetailsComponent implements OnInit {

  item: AdamsDocModel = {};

  constructor(public dialogRef: DynamicDialogRef, public config: DynamicDialogConfig,) {
  }

  ngOnInit(): void {
    this.item = this.config.data;
  }

  hideDialog(){
    this.dialogRef.close();
  }
}

